// extracted by mini-css-extract-plugin
module.exports =  {"slider":"_93444fe79c--slider--FrvTI","cont":"_93444fe79c--cont--Xn3R3","cont--empty":"_93444fe79c--cont--empty--KrcHJ"};